import React from 'react';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../../components/PageHeader';
import PageHeaderNav from '../../../components/PageHeaderNav';
import { useFlairBreadcrumbHook } from '../../../../../hooks/useFlairBreadcrumbHook';
import { useServerFeature } from '../../../../../hooks/useServerFeature';
import { routes } from '../../../routes';

const PersonalDataHeader: React.FC = () => {
  const { t } = useTranslation();
  const isProfileVisible = useServerFeature('Employee_Profile');
  useFlairBreadcrumbHook([
    { label: t('navigation.menuItems.profile.title') },
    { label: t('personalData.subMenuTitle') },
  ]);

  const tabItems = [
    {
      label: t('personalData.tabs.details'),
      route: routes.personalData.route,
    },
    ...(isProfileVisible
      ? [
          {
            label: t('personalData.tabs.profile'),
            route: routes.personalDataProfile.route,
          },
        ]
      : []),
  ];

  return (
    <PageHeader title={t('personalData.subMenuTitle')}>
      <PageHeaderNav tabItems={tabItems} />
    </PageHeader>
  );
};

export default PersonalDataHeader;
